// %checks is from Flow failing to recognise null/undefined check in function https://github.com/facebook/flow/issues/3417

import _ from 'lodash'

export const isNil = (value) => {
  return value == null || Number.isNaN(value)
}

export const isNotNil = (value) => {
  return !isNil(value)
}

export const isString = (value) => {
  return isNotNil(value) && typeof value === 'string' && _.isString(value)
}

export const isNumber = (value) => {
  return _.isNumber(value) && !Number.isNaN(value)
}

export const isObject = (value) => {
  return isNotNil(value) && typeof value === 'object' && _.isPlainObject(value)
}

export const isArray = (value) => {
  return isNotNil(value) && value instanceof Array
}

export const isEmpty = (value) => {
  return isNil(value) || _.isEmpty(value)
}
